<template>
  <div class="content main-container">
    <div class="search-box">
      <div class="input-item">
        <span class="label">用户昵称</span>
        <Input v-model="searchParams.nickName" placeholder="请输入用户昵称" clearable />
      </div>
      <Button type="primary" @click="getList()">查询</Button>
      <Button type="primary" @click="open()" v-if="$units.pointAction('content_3_3_1')">+新增</Button>
    </div>
    <div class="tableBox">
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{row}" slot="headImage">
          <img class="headImage" :src="row.headImage" alt='' />
        </template>
        <template slot-scope="{ row }" slot="action">
          <div>
            <span class="table-btn" @click="editModal(row.id)" v-if="$units.pointAction('content_3_3_2')">编辑</span>
            |
            <span class="table-btn" @click="deleteOne(row.id)" v-if="$units.pointAction('content_3_3_3')">删除</span>
          </div>
        </template>
      </Table>
    </div>
    <div class="pageBox">
        <Page
          :total="total"
          :current="pageNo"
          :page-size="pageSize"
          show-total
          @on-change="pageChange"
          style="text-align: center"
        />
      </div>
    <Modal v-model="visible" :title="title" :mask-closable="false" :footer-hide="true">
      <Form ref="form" :model="formData" :label-width="80" class="formGauge">
        <FormItem label="头像" prop="headImage" :rules="$units.formRule.required('请选择头像')">
          <uploadNew fileType="img" v-model="formData.imgArr" @change="imgUpload"
            @remove="$set(formData, 'headImage', '')"></uploadNew>
        </FormItem>
        <FormItem label="用户名" prop="nickName" :rules="$units.formRule.required('请输入用户名')">
          <Input v-model="formData.nickName" placeholder="请输入" clearable />
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="submit" v-preventReClick>确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import uploadNew from '@/components/commons/uploadNew';
import { pageTool } from "@/api/mixins";
export default {
  components: { uploadNew },
  mixins: [pageTool],
  data() {
    return {
      title: '新增用户',
      visible: false,
      searchParams: {},
      total: 0,
      pageNo: 1,
      pageSize: 10,
      columns: [
        {
          title: "头像",
          key: 'headImage',
          slot: 'headImage',
          minwidth: 160,
          align: 'center',
        },
        {
          title: "用户昵称",
          key: 'nickName',
          minwidth: 160,
          align: 'center'
        },
        {
          title: "更新时间",
          key: 'updateTime',
          minwidth: 180,
          align: 'center',
        },
        {
          title: "操作",
          slot: "action",
          align: 'center',
          width: 160,
        }
      ],
      formData: {}
    }
  },
  created() {
    if (!this.$units.pointAction('content_3_3_2') && !this.$units.pointAction('content_3_3_3')) {
      this.columns.splice(this.columns.length - 1, 1);
    }
    this.initListAjax("/buz/friendsCircleUser/read/list");
  },
  methods: {
    pageChange(pageNo) {
      this.pageNo = pageNo;
      this.getList(pageNo);
    },
    open(data) {
      this.visible = true
      this.formData = {}
      this.$refs.form && this.$refs.form.resetFields();
      if (data) {
        this.title = '编辑用户'
        if (data.headImage) {
          data.imgArr = [{ path: data.headImage }];
        }
        this.formData = data
      } else {
        this.title = '新增用户'
      }
    },
    editModal(id) {
      this.$http({
        url: '/buz/friendsCircleUser/read/detail',
        type: "GET",
        data: {
          id: id
        }
      }).then(res => {
        this.open(res.data)
      })
    },
    // 删除
    deleteOne(id) {
      this.$notice.inquiry('是否确认删除此选项？').then(async () => {
        this.$http({
          url: '/buz/friendsCircleUser/del',
          type: "GET",
          data: {
            id: id
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.getList()
        })
      })
    },
    // 新增编辑用户
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          delete this.formData.imgArr
          this.$http({
            url: this.formData.id ? '/buz/friendsCircleUser/edit' : '/buz/friendsCircleUser/add',
            type: "POST",
            data: this.formData
          }).then(res => {
            this.$notice.success('操作成功');
            this.visible = false
            this.getList()
          })
        }
      });
    },
    imgUpload() {
      if (this.formData.imgArr && this.formData.imgArr[0]) {
        this.$set(this.formData, "headImage", this.formData.imgArr[0].path)
      }
      this.$refs.form.validateField('headImage');
    },
  }
}
</script>

<style lang="scss" scoped>
.headImage {
  width: 50px;
  height: 50px;
  margin: 10px 0;
  border-radius: 8px;
  object-fit: cover;
}
.pageBox {
  margin-top: 20px;
}
/deep/ .ivu-upload > div{
  background: #F7F7F7;
}
/deep/ .iconColor{
  color: #C0C4CC;
  
}
/deep/ .wrapper .demo-upload-list img{
  object-fit: cover;
}
</style>